import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mediaGroup } from '@atlaskit/adf-schema';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

/**
 * Duplicate consts from `media-card`.
 * `packages/media/media-card/src/utils/cardDimensions.ts`
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `media-card` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */
export var defaultImageCardDimensions = {
  width: 156,
  height: 125
};
export var defaultHorizontalCardDimensions = {
  width: 435,
  height: 125
};
export var defaultSquareCardDimensions = {
  width: 300,
  height: 300
};

/**
 * Duplicate logic from `@atlaskit/media-card` for computing the dimensions of a media group card.
 * From: `packages/media/media-card/src/utils/cardDimensions.ts`
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/media-card` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */
export var getDefaultCardDimensions = function getDefaultCardDimensions() {
  var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
  if (appearance === 'image') {
    return defaultImageCardDimensions;
  }
  if (appearance === 'square') {
    return defaultSquareCardDimensions;
  }
  if (appearance === 'horizontal') {
    return defaultHorizontalCardDimensions;
  }
  return defaultImageCardDimensions;
};

// @nodeSpecException:toDOM patch
export var mediaGroupSpecWithFixedToDOM = function mediaGroupSpecWithFixedToDOM() {
  if (editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return mediaGroup;
  }
  return _objectSpread(_objectSpread({}, mediaGroup), {}, {
    toDOM: function toDOM(node) {
      // Margin margin that consolidates the margin in the
      return ['div', {
        style: "\n\t\t\t\t\t\tmargin: 3px 5px;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tgap: 8px;\n\t\t\t\t\t\t--ak-editor-media-card-background-color: #EBECF0;\n\t\t\t\t\t\t--ak-editor-media-card-width: ".concat(defaultImageCardDimensions.width, "px;\n\t\t\t\t\t\t--ak-editor-media-card-height: ").concat(defaultImageCardDimensions.height, "px;\n\t\t\t\t\t"),
        'data-node-type': 'mediaGroup'
      }, 0];
    }
  });
};